$(document)
  .on('click', '[data-modal]:not([disabled])', function (e) {
    e.preventDefault();
    $('#modal .modal-content').load($(this).data('modal'), function () {
      const $modalEl = $('#modal');
      if ($modalEl.length) {
        const modal = new bootstrap.Modal($modalEl[0]);
        modal.show();
      }
    });
  })
  .on('click', '.open-form', function (e) {
    // e.preventDefault();
    $.ajax({
      url: '/form',
      type: 'GET',
      success: function (data) {
        $('#form-pjax').html(data);
        // $('html, body').animate({ scrollTop: $('#main').offset().top }, 500);
      },
      error: function () {
        console.error('Помилка завантаження форми');
      }
    });
  })
  .on('change', '#upload-form #file-upload-input', function () {
    const fileName = this.files[0] ? this.files[0].name : '';
    const field = $(this).closest('.field-file-upload-input');
    const fileInput = this;

    // Видаляємо попередню інформацію про файл та помилки
    field.find('.file-info').remove();
    field.find('.invalid-feedback').remove();
    field.removeClass('has-error');

    if (fileName && this.files[0]) {
      field.append('<div class="file-info"><code>' + fileName + '</code></div>');

      // Обчислюємо MD5 хеш файлу
      const file = this.files[0];
      const reader = new FileReader();

      reader.onload = function(e) {
        // Використовуємо crypto-js для обчислення MD5
        const wordArray = CryptoJS.lib.WordArray.create(e.target.result);
        const hash = CryptoJS.MD5(wordArray).toString();

        // Перевіряємо чи існує файл з таким хешем
        $.ajax({
          url: '/site/check-file-hash',
          type: 'POST',
          data: {
            hash: hash,
            [yii.getCsrfParam()]: yii.getCsrfToken()
          },
          success: function(response) {
            if (response.exists) {
              // Додаємо помилку до поля
              field.addClass('has-error');
              field.append('<div class="invalid-feedback d-block">' + response.message + '</div>');

              // Блокуємо кнопку відправки форми
              $('#submit-button').prop('disabled', true);
            } else {
              // Розблоковуємо кнопку відправки форми
              $('#submit-button').prop('disabled', false);
            }
          },
          error: function() {
            console.error('Помилка перевірки файлу');
          }
        });
      };

      setTimeout(function () {reader.readAsArrayBuffer(file);},1000);

    } else {
      // Розблоковуємо кнопку якщо файл не вибрано
      $('#submit-button').prop('disabled', false);
    }
  })

  // .on('click', 'a[href^="#"]', function(e) {
  //       e.preventDefault();
  //       var targetId = $(this).attr('href');
  //       if (targetId === '#') return;
  //       var target = $(targetId);
  //       if (target.length) {
  //           var headerHeight = 0; $('header').outerHeight() || 80;
  //           var targetPosition = target.offset().top - headerHeight;
  //           $('html, body').animate({
  //               scrollTop: targetPosition
  //           }, 800);
  //       }
  //   })

  .on('click', '.faq-question', function(e) {
    $(this).find('.faq-toggle').toggleClass('active');
    $(this).next('.faq-answer').toggleClass('active');
  })

  // .on('click', '[data-scroll]', function(e) {
  //   e.preventDefault();
  //   let to = $(this).data('scroll');
  //   setTimeout(function() {
  //     $('html, body').animate({
  //       scrollTop: $(to).offset().top
  //     }, 800);
  //   }, 50);
  // })

  .on('click', '.remove-parent', function() {
    $(this).parent().remove();
  // })

  // .on('submit', '#support-form', function(e) {
  //   e.preventDefault();

  //   const form = $(this);
  //   const formData = new FormData(this);

  //   $.ajax({
  //     url: form.attr('action'),
  //     type: 'POST',
  //     data: formData,
  //     processData: false,
  //     contentType: false,
  //     success: function(data) {
  //       $('#contact-pjax').html(data);
  //     },
  //     error: function() {
  //       console.error('Помилка відправки форми');
  //     }
  //   });
  });
